
$(function () {

    $(document).on('click', '.fav-btn', function (event) {

        event.preventDefault();

        let car_id = $(this).data('car-id');
        let d_btn = $(this).data('deleted-button');

        let def = $.ajax({
            url: "/favorite",
            type: 'post',

            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: {
                car_id: car_id
            },
        beforeSend: function(xhr, settings) {
            startload();
        },

    }).then(function (data) {

            if (d_btn) {

                $('#card_id' + car_id).prev().remove();
                $('#card_id' + car_id).removeClass('d-none').addClass('d-block');

            } else {

                $('#card_id' + car_id).before('<div class="card custom-card d-block mb-3 py-3 text-primary text-center fav-btn" data-deleted-button="true" data-car-id="' + car_id + '" style="cursor: pointer; height:280px;"><div class="text-center btn btn-outline-secondary btn-lg" style="margin-top: 110px;">元に戻す</div></div>');
                $('#card_id' + car_id).addClass('d-none').removeClass('d-block');
            }



        }, function (data) {

        });

        setTimeout(function(){
            $.when(def).done(function(data){
                stopload();
            });
        }, 1000);


    });
});
